import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import * as $ from 'jquery';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Storage } from '@ionic/storage';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Http, HttpOptions } from '@capacitor-community/http';
import { from, Observable, Subscription } from 'rxjs';
import { AlertController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular';
import * as QRCode from 'qrcode';
import { ToastController } from '@ionic/angular';
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { AesRandomizerService } from 'src/app/randomizer_service/aes-randomizer.service';
import { GetDataType, PostDataType } from './service.types';
import { finalize } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ServiceService {
  // LocalStorage wrapper with proper typing
  localStorage = {
    getItem: (key: string): string => {
      return localStorage.getItem(key) || '';
    },
    setItem: (key: string, value: string): void => {
      localStorage.setItem(key, value);
    },
    removeItem: (key: string): void => {
      localStorage.removeItem(key);
    }
  };

  // Check authentication status
  async checkAuthState(): Promise<boolean> {
    const pin = this.localStorage.getItem('user_pin');
    return !!pin;
  }

  // Handle logout
  // Removed duplicate async logout(): Promise<void> to resolve duplicate function implementation error.

  // Handle initial navigation
  async handleInitialNavigation(): Promise<void> {
    const isAuthenticated = await this.checkAuthState();

    if (isAuthenticated) {
      this.router.navigate(['/pinlogin'], { replaceUrl: true });
    } else {
      this.router.navigate(['/home'], { replaceUrl: true });
    }
  }
  app_pin_key: string = 'SpPIN';
  session_key = '';
  result = {
    action: '1',
    response: {},
  };
  response = {};
  action = '1';
  isLoading = false;
  isadmin: boolean;
  cpt_session_keys = {
    mod0101: '',
    mod0102: '',
    mod0123: '',
    mod0129: '',
    mod0132: '',
    mod0133: '',
    mod0184: '',
  };
  show_spinner: boolean = false;

  privilage_array = [];

  private treeData: any[] = [];
  lat: any;
  lon: any;

  private sharedData: any;
  DefaultModuleName: any;

  nav_stack = [];

  backButtonSubscription: Subscription;

  alert_exist: Boolean = false;
  cpt_views = {
    mod0129: {
      'session-for': 'captcha-course_reg-user',
      'cptid-keyname': 'creg-user-cptid',
    },
    mod0101: {
      'session-for': 'captcha-login',
      'cptid-keyname': 'cptid',
    },
    mod0102: {
      'session-for': 'captcha-register',
      'cptid-keyname': 'reg-cptid',
    },
    mod0123: {
      'session-for': 'captcha-mobno_validate',
      'cptid-keyname': 'mobno-cptid',
    },
    mod0132: {
      'session-for': 'captcha-course_reg_old',
      'cptid-keyname': 'creg_old-cptid',
    },
    mod0133: {
      'session-for': 'captcha-course_reg-open',
      'cptid-keyname': 'creg-cptid',
    },
    mod0184: {
      'session-for': 'captcha-user-kyc',
      'cptid-keyname': 'kyc-user-cptid',
    },
    home: {
      'session-for': 'captcha-home',
      'cptid-keyname': 'home-cptid',
    },
    'new-home': {
      'session-for': 'captcha-new-home',
      'cptid-keyname': 'new-home-cptid',
    },
  };
  constructor(
    private http: HttpClient,
    public loadingController: LoadingController,
    public alertController: AlertController,
    private storage: Storage,
    public platform: Platform,
    private router: Router,
    private cookies: CookieService,
    private toastController: ToastController,
    private ardService: AesRandomizerService
  ) {
    this.isadmin = this.parseBoolean(this.localStorage.getItem('isadmin'));
    console.log('test cpt id on service init :');
    for (const [key, value] of Object.entries(this.cpt_views)) {
      console.log(
        `
        view_name = ${key}; 
        key_name = ${value['cptid-keyname']}; 
        key_value = ${this.localStorage.getItem(value['cptid-keyname'])}
        `
      );
    }

  }
  parseBoolean(value: string): boolean {
    return value.toLowerCase() === 'true';
  }
  platform_back_button_function(url: String) {
    var back_url: String = '/master';

    if (url == 'buyer-aop') {
      back_url = '/session-home-page';
    } else if (url == 'forgot-pass-app') {
      back_url = '/login-page-app';
    } else if (url.includes('setpin')) {
      back_url = '/login-page-app';
    } else if (url.includes('new-home')) {
      back_url = '/session-home-page';
    } else if (url == 'new-user-page') {
      back_url = '/login-page-app';
      // this.confirmExitApp();

    } else if (url == 'session-home-page') {
      back_url = '/session-home-page';
      this.confirmExitApp();

    } else {
      back_url = '/session-home-page';
    }

    return back_url;
  }

  SplitUrl(url: String) {
    var parts = url.split('/');
    var lastPart = parts[parts.length - 1].split("?")[0];
    this.DefaultModuleName = lastPart;
    return lastPart;
  }

  setSharedData(data: any) {
    this.sharedData = data;
  }

  getSharedData() {
    return this.sharedData;
  }

  // jinoth Qr entry
  //position:'top' | 'middle' | 'bottom'
  async presenttoast(
    msg: any,
    position: 'top' | 'middle' | 'bottom' = 'middle'
  ) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 1500,
      position: position,
    });

    await toast.present();
  }

  getLocation() {
    if (navigator.geolocation) {
      return navigator.geolocation.getCurrentPosition((pos) =>
        this.showPosition(pos)
      );
    }
  }

  showPosition(position: any) {
    this.lat = position.coords.latitude;
    this.lon = position.coords.longitude;
  }

  generateQRCode(data: string): Promise<string> {
    return new Promise((resolve, reject) => {
      QRCode.toDataURL(data, (err, url) => {
        if (err) {
          reject(err);
        } else {
          resolve(url);
        }
      });
    });
  }

  IsValidMobileNumber(mobileNumber) {
    // Remove any non-digit characters
    const cleanedNumber = mobileNumber.replace(/\D/g, '');

    // Check if the cleaned number has exactly 10 digits and is not all zeros
    return /^\d{10}$/.test(cleanedNumber) && cleanedNumber !== '0000000000';
  }

  // call_api_post_ajax(
  //   url: string,
  //   data: { [key: string]: any },
  //   modname: string = '',
  //   callback: Function = () => {}
  // ): void {
  //   $.ajax({
  //     url: url,
  //     method: 'POST',
  //     headers: {
  //       Authorization: this.get_session_id_login(),
  //       'Content-Type': 'application/json',
  //       // modname: modname,
  //     },
  //     data: JSON.stringify({ ...data, modname }),
  //     success: function (response) {
  //       callback(response);
  //     },
  //     error: function (xhr, status, error) {
  //       console.log('Error:', error);
  //     },
  //   });
  // }

  call_api_post(
    url: string,
    data: { [key: string]: any } | FormData,
    modname: string = '',
    isFormData: boolean = false
  ): Observable<any> {
    if (isFormData) data.append('modname', modname);
    else data = { ...data, modname };
    const headers = {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
      Authorization: this.get_session_id_login(),
    };
    return this.http.post(url, data, { headers });
  }

  appendParamsToGetUrl(
    url: string,
    data: { [key: string]: string | number | null }
  ): string {
    let urlobj = new URL(url);
    for (let key in data) {
      if (data[key] != null)
        urlobj.searchParams.set(key, String(data[key]));
    }
    return urlobj.href;
  }

  // defaultErrHandler = (err: any) => {
  //   console.log(err);
  //   this.alert.warningAlert({
  //     text: 'An error occurred',
  //     action: 'error',
  //   });
  // };

  // defaultErrHandler = (err: any, onErrModalHide = () => { }) => {
  //   console.log(err);
  //   const {
  //     error: errData,
  //     headers,
  //     message,
  //     name,
  //     status,
  //     statusText,
  //     url,
  //   } = err;
  //   console.log(err);

  //   let errText = 'An error occurred';
  //   if (status == 403) {

  //     // to clear local session
  //     this.localStorage.removeItem('pagesession');
  //     // errText = errData?.detail || 'Invalid Session Key';
  //     errText = errData?.detail;

  //     if (errText == 'Session Expired') {

  //       // TODO: debug for android

  //       if (Capacitor.getPlatform() === 'android') {
  //         // goto pinlogin page only for android app
  //         this.alert.warningAlert({
  //           text: 'Your Session Has Expired, Please Login',
  //           action: 'warning',
  //           callback: () => {
  //             onErrModalHide()
  //             window.location.replace('/pinlogin');
  //           },
  //         });
  //       } else {
  //         // alert and redirect to login after properly clearing localstorage data of user


  //         // this.alert.warningAlert({
  //         //   text: 'Your Session Has Expired, Please Login',
  //         //   action: 'warning',
  //         //   callback: () => {
  //         //     onErrModalHide()
  //             this.logout();
  //         //   },
  //         // });
  //       }
  //     } else {
  //       // this.alert.warningAlert({
  //       //   text: errText,
  //       //   action: 'error',
  //       //   callback: () => {
  //       //     onErrModalHide()
  //           this.logout();
  //       //   }
  //       // });
  //     }
  //   } else if (status == 0) {
  //     errText = 'Network Error';
  //     this.alert.warningAlert({
  //       text: errText,
  //       action: 'error',
  //       callback: () => {
  //         // TODO: hide loader if needed
  //         if (this.show_spinner) this.show_spinner = false;
  //       }
  //     });
  //   } else {
  //     this.common_errorCb(err, '', onErrModalHide);
  //   }
  // }

  defaultErrHandler = (err: any, onErrModalHide = () => {}) => {
  console.log(err);

  const { error: errData, status } = err;

  if (status === 403) {
    this.localStorage.removeItem('pagesession');

    // ✅ ANDROID மட்டும் alert
    if (Capacitor.getPlatform() === 'android') {

      this.alert.warningAlert({
        text: 'Your Session Has Expired, Please Login',
        action: 'warning',
        callback: () => {
          onErrModalHide();
          window.location.replace('/pinlogin');
        },
      });
    } else {
      // ✅ WEB → NO ALERT, direct logout
      onErrModalHide?.();
      this.logout();
    }

    return; // 🔥 IMPORTANT
  }

  if (status === 0) {
    this.alert.warningAlert({
      text: 'Network Error',
      action: 'error',
      callback: () => {
        if (this.show_spinner) this.show_spinner = false;
      }
    });
    return;
  }

  this.common_errorCb(err, '', onErrModalHide);
};

  common_errorCb = (err, errTxt = '', onModalHide = () => { }) => {
    console.log(err);
    this.alert.warningAlert({
      text: errTxt || 'An error occurred',
      // action: 'error',
      callback: () => {
        // TODO: hide loader if needed
        onModalHide()
        if (this.show_spinner) this.show_spinner = false;
      },
    });
  };

  defaultCompleteHandler = () => {
    // console.log('http post completed');
  };

  // call_http_get(getObj: GetDataType): Subscription {
  //   const {
  //     url,
  //     modname = '',
  //     successCb = (response) => {},
  //     errorCb = this.defaultErrHandler,
  //     completeCb = this.defaultCompleteHandler,
  //   }: GetDataType = getObj;

  //   const headers = {
  //     Authorization: this.get_session_id_login(),
  //   };

  //   return this.http
  //     .get(this.appendParamsToGetUrl(url, { modname }), {
  //       headers,
  //     })
  //     .subscribe(successCb, errorCb, completeCb);
  // }

  // call_http_post(postObj: PostDataType): Subscription {
  //   const {
  //     url,
  //     modname = '',
  //     isFormData = false,
  //     successCb = (response) => {},
  //     errorCb = this.defaultErrHandler,
  //     completeCb = this.defaultCompleteHandler,
  //   }: PostDataType = postObj;

  //   let data = postObj.data;
  //   if (!data) {
  //     if (isFormData) data = new FormData();
  //     else data = {};
  //   }
  //   if (isFormData) data.append('modname', modname);
  //   else data = { ...data, modname };

  //   const headers = {
  //     Authorization: this.get_session_id_login(),
  //   };

  //   if (!isFormData) headers['Content-Type'] = 'application/json';

  //   // // using Http.request doesnt get intercepted by HttpInterceptor
  //   // const options: HttpOptions = { url, method: 'POST', headers, data };
  //   // return from(Http.request(options));

  //   return this.http
  //     .post(url, data, { headers })
  //     .subscribe(successCb, errorCb)
  //     .add(completeCb);
  // }

  private getLSItem = (key: string) => {
    return this.ardService.removeRandomizer(
      localStorage.getItem(this.ardService.applyRandomizer(key)) ||
      AesRandomizerService.emptyStr
    );
    // default value : null
  };

  private setLSItem = (key: string, value: string) => {
    if (value == null || value == undefined) value = '';
    localStorage.setItem(
      this.ardService.applyRandomizer(key),
      this.ardService.applyRandomizer(value)
    );
  };

  private removeLSItem = (key: string) => {
    localStorage.removeItem(this.ardService.applyRandomizer(key));
  };

  // localStorage = {
  //   getItem: this.getLSItem,
  //   setItem: this.setLSItem,
  //   removeItem: this.removeLSItem,
  // };

  get_session_id_login() {
    // if (this.platform.is('cordova')) {
    //      return "";
    // }
    // else
    // {
    return this.localStorage.getItem('token');
    // }
  }

  get_user_details_in_cookies() {
    return this.localStorage.getItem('user_name');
  }

  // For alert
  async presentAlert(input_msg: any, callback: Function = () => { }) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      // header: 'Message',
      message: input_msg,
      buttons: ['OK'],
    });

    await alert.present();

    // const { role } = await alert.onDidDismiss()
    // console.log('onDidDismiss resolved with role', role);

    alert.onDidDismiss().then(() => callback());
  }

  // For alert
  async presentAlert2(input_msg) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      // header: 'Message',

      message: input_msg,
      buttons: ['OK'],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  // async presentAlertConfirm() {
  //   const alert = await this.alertController.create({
  //     cssClass: 'my-custom-class',
  //     header: 'User not Found',
  //     message: 'Are you want to register?',
  //     buttons: [
  //       {
  //         text: 'Try again',
  //         role: 'cancel',
  //         cssClass: 'secondary',
  //         id: 'cancel-button',
  //         handler: (blah) => {
  //           console.log('Confirm Cancel: blah');
  //         }
  //       }, {
  //         text: 'Register',
  //         id: 'confirm-button',
  //         handler: () => {
  //           this.router.navigate(['/mod0123'])
  //         }
  //       }
  //     ]
  //   });

  //   await alert.present();
  // }

  async presentAlertConfirm() {
    this.alert.confirmationAlert({
      title: 'User Not Found',
      text: 'Are You Want to Register?',
      confirmCallback: () => {
        this.router.navigate(['/mod0123']);
      },
      cancelCallback: () => {
        this.warningAlert({
          title: 'User Not Found',
          text: 'Try again',
          action: 'warning',
        });
        this.alert_exist = false;
      },
    });
  }

  async presentConfirm(opts: any = {}) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: opts.header || '',
      message: opts.text || 'Kindly confirm this to proceed',
      buttons: [
        {
          text: opts.okBtnText || 'OK',
          id: 'confirm-button',
          handler: opts.okbtnHandler,
        },
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: opts.cancelHandler,
        },
      ],
    });

    await alert.present();
  }

  async presentConfirm1(opts: any = {}) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: opts.header || '',
      message: `<p> ARE YOU SURE YOU WANTS TO CONFIRM THE JOB APPLICATION ? <p> <br>     
                
              <p>BY CLICKING YES, YOU ARE CONFORMING THE GIVEN INFORMATION IS TRUE AND CORRECT TO THE BEST OF YOUR KNOWLEDGE.<p>`,
      buttons: [
        {
          text: opts.okBtnText || 'YES',
          id: 'confirm-button',
          handler: opts.okbtnHandler,
        },
        {
          text: 'NO',
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: opts.cancelHandler,
        },
      ],
    });

    await alert.present();
  }

  async presentModalLoader(props: {
    text?: string;
    showForMs?: number;
    onPresent?: () => void;
  }) {
    let { text: message, showForMs: duration, onPresent = () => { } } = props;
    console.log({ message, duration });
    this.isLoading = true;
    return await this.loadingController
      .create({
        message,
        duration,
        // animated: true, backdropDismiss: false,
      })
      .then((a) => {
        a.present().then(() => {
          onPresent();
          // a.dismiss().then(() => console.log('dismissed'))
        });
      });
  }

  async dismissModalLoader(onDismiss?: () => void) {
    if (!onDismiss) onDismiss = () => { };
    this.isLoading = false;
    return await this.loadingController.dismiss().then(onDismiss);
  }

  scroll_event(id) {
    document
      .querySelector(id)
      .scrollIntoView({ behavior: 'smooth', block: 'start' });
  }


  onContentScroll(event) {
    // Handle the scroll event here
    // You can access event.detail.scrollTop to get the current scroll position
    const scrollTop = event.detail.scrollTop;
    console.log('Scroll position:', scrollTop);

    // You can add your custom logic based on the scroll position
    if (scrollTop > 100) {
      // Do something when scrolled beyond a certain point
    }
  }

  logout() {
    this.call_http_post({
      url: environment.API_URL + 'mastermodule/logout',
      data: {
        user_id: this.localStorage.getItem('user_id'),
        login_dt: this.localStorage.getItem('login_dt'),
        sid: this.get_session_id_login(),
      },
      successCb: (res) => {
        var result = res.data;
        // console.log({ result });
        // let { message } = result;
        // if message == "ok"
        // this.clearUserSession();
        // window.location.replace('/home');
        const isAndroid = Capacitor.getPlatform() === 'android';

        if (isAndroid) {
          this.clearUserSession();
          window.location.replace('/session-home-page');
        }
        else {
          this.clearUserSession();
          window.location.replace('master/mod0334');

        }
      },
    });
  }


  publiclogout() {
    this.call_http_post({
      url: environment.API_URL + 'mastermodule/logout',
      data: {
        user_id: this.localStorage.getItem('publicuserid'),
        login_dt: this.localStorage.getItem('login_dt'),
        sid: this.localStorage.getItem('pagesession'),
      },
      successCb: (res) => {
        var result = res.data;
        this.clearUserSession();
        window.location.replace('/home');
      },
    });
  }


  clearUserSession() {
    // Clear App PIN
    this.localStorage.removeItem(this.app_pin_key);
    this.localStorage.removeItem('token');
    this.localStorage.removeItem('user_id');
    this.localStorage.removeItem('isAdmin');
    this.localStorage.removeItem('user_type');
    this.localStorage.removeItem('user_name');
    this.localStorage.removeItem('designation');
    this.localStorage.removeItem('mobile');
    this.localStorage.removeItem('user_branch');
    this.localStorage.removeItem('user_region');
    this.localStorage.removeItem('user_staff_id');
    this.localStorage.removeItem('user_region_id');
    this.localStorage.removeItem('user_branch_id');
    this.localStorage.removeItem('lastlog');
    this.cookies.delete('session_key');
    this.cookies.delete('user_id');
    this.cookies.delete('isAdmin');
    this.cookies.delete('user_type');
    this.cookies.delete('user_name');
    // environment.session_key = '';
    this.session_key = '';
    window.location.replace('/home');

  }

  clearNewUserSession() {
    // Clear App PIN
    this.localStorage.removeItem(this.app_pin_key);
    this.localStorage.removeItem('token');
    this.localStorage.removeItem('user_id');
    this.localStorage.removeItem('isAdmin');
    this.localStorage.removeItem('user_type');
    this.localStorage.removeItem('user_name');
    this.localStorage.removeItem('designation');
    this.localStorage.removeItem('mobile');
    this.localStorage.removeItem('user_branch');
    this.localStorage.removeItem('user_region');
    this.localStorage.removeItem('user_staff_id');
    this.localStorage.removeItem('user_region_id');
    this.localStorage.removeItem('user_branch_id');
    this.localStorage.removeItem('lastlog');
    this.cookies.delete('session_key');
    this.cookies.delete('user_id');
    this.cookies.delete('isAdmin');
    this.cookies.delete('user_type');
    this.cookies.delete('user_name');
    this.session_key = '';

  }

  //ROWS SHOWING FUNCTION
  showig_rows_count(maxRows, pageNum, totalRows) {
    //Default rows showing
    var end_index = maxRows * pageNum;
    var start_index = maxRows * pageNum - maxRows + 1;
    var string =
      'Showing ' +
      start_index +
      ' to ' +
      end_index +
      ' of ' +
      totalRows +
      ' entries';
    $('.rows_count').html(string);
  }

  getDT(dt) {
    let dtObj = new Date(dt);
    return dtObj.toLocaleDateString() + ' ' + dtObj.toLocaleTimeString();
  }
  getMonthName(m) {
    var month_names = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return month_names[m];
  }
  getMonthNameShort(m) {
    var month_names_short = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return month_names_short[m];
  }

  getDTperFormat(dt, format = 'dd/MM/yyyy hh:mm ap') {
    let dtObj = new Date(dt);
    format = format.replace(
      'yyyy',
      String(dtObj.getFullYear()).padStart(4, '0')
    );
    format = format.replace('MMMM', this.getMonthName(dtObj.getMonth()));
    format = format.replace('MMM', this.getMonthNameShort(dtObj.getMonth()));
    format = format.replace(
      'MM',
      String(dtObj.getMonth() + 1).padStart(2, '0')
    );
    format = format.replace('dd', String(dtObj.getDate()).padStart(2, '0'));
    format = format.replace('HH', String(dtObj.getHours()).padStart(2, '0'));
    format = format.replace('mm', String(dtObj.getMinutes()).padStart(2, '0'));
    let hr = dtObj.getHours();
    let hh = hr % 12;
    let apm = 'AM';
    if (hr >= 12) {
      apm = 'PM';
      if (hr == 12) hh = 12;
    }
    format = format.replace('hh', String(hh).padStart(2, '0'));
    format = format.replace('ss', String(dtObj.getSeconds()).padStart(2, '0'));
    format = format.replace('ap', apm);
    return format;
  }

  getUTCdateStr(dt) {
    let dtObj = new Date(dt);
    return (
      dtObj.getUTCFullYear() +
      '-' +
      String(dtObj.getUTCMonth() + 1).padStart(2, '0') +
      '-' +
      String(dtObj.getUTCDate()).padStart(2, '0') +
      ' ' +
      String(dtObj.getUTCHours()).padStart(2, '0') +
      ':' +
      String(dtObj.getUTCMinutes()).padStart(2, '0') +
      ':00'
    );
  }

  // should be done in backend
  validateAdmin() {
    return this.localStorage.getItem('isAdmin') == 'true';
    /*
    this.call_api_post("", {
      session_key: this.get_session_id_login()
    }).subscribe((res:any) => {
      var result = res.data
      return result['isAdmin'] == 1;
    })
    */
  }

  intToEnglish(number) {
    var NS = [
      { value: 10000000, str: 'Crore' },
      { value: 100000, str: 'Lakh' },
      { value: 1000, str: 'Thousand' },
      { value: 100, str: 'Hundred' },
      { value: 90, str: 'Ninety' },
      { value: 80, str: 'Eighty' },
      { value: 70, str: 'Seventy' },
      { value: 60, str: 'Sixty' },
      { value: 50, str: 'Fifty' },
      { value: 40, str: 'Forty' },
      { value: 30, str: 'Thirty' },
      { value: 20, str: 'Twenty' },
      { value: 19, str: 'Nineteen' },
      { value: 18, str: 'Eighteen' },
      { value: 17, str: 'Seventeen' },
      { value: 16, str: 'Sixteen' },
      { value: 15, str: 'Fifteen' },
      { value: 14, str: 'Fourteen' },
      { value: 13, str: 'Thirteen' },
      { value: 12, str: 'Twelve' },
      { value: 11, str: 'Eleven' },
      { value: 10, str: 'Ten' },
      { value: 9, str: 'Nine' },
      { value: 8, str: 'Eight' },
      { value: 7, str: 'Seven' },
      { value: 6, str: 'Six' },
      { value: 5, str: 'Five' },
      { value: 4, str: 'Four' },
      { value: 3, str: 'Three' },
      { value: 2, str: 'Two' },
      { value: 1, str: 'One' },
    ];

    var result = '';
    for (var n of NS) {
      if (number >= n.value) {
        if (number <= 99) {
          result += n.str;
          number -= n.value;
          if (number > 0) result += ' ';
        } else {
          var t = Math.floor(number / n.value);
          // console.log(t);
          var d = number % n.value;
          if (d > 0) {
            return (
              this.intToEnglish(t) + ' ' + n.str + ' ' + this.intToEnglish(d)
            );
          } else {
            return this.intToEnglish(t) + ' ' + n.str;
          }
        }
      }
    }
    return result;
  }

  // To Convert Table in to PDF

  // async generatePDF(table_card_1,table_id,table_heading ='REPORT',table_name='REPORT',font_size=8) {
  //   if(this.alert_exist==false)
  //   {
  //     this.alert_exist=true
  //     const alert = await this.alertController.create({
  //       header: 'Confirmation',
  //       message: 'Are You Sure Want To Download The PDF ?',
  //       buttons: [
  //         {
  //           text: 'Cancel',
  //           role: 'cancel',
  //           cssClass: 'secondary',
  //           handler: () => {
  //             return
  //           }
  //         }, {
  //           text: 'OK',
  //           handler: () => {

  //             this.Confirm_generatePDF(table_card_1,table_id,table_heading ='REPORT',table_name='REPORT',font_size=8)

  //           }
  //         }
  //       ]
  //     });

  //     await alert.present();
  //     this.alert_exist=false
  //   }
  // }

  async generatePDF(
    table_card_1,
    table_id,
    table_heading = 'REPORT',
    table_name = 'REPORT',
    font_size = 8
  ) {
    if (this.alert_exist == false) {
      this.alert_exist = true;

      this.confirmationAlert({
        text: 'Are You Sure Want To Download The PDF ?',
        confirmCallback: () => {
          this.Confirm_generatePDF(
            table_card_1,
            table_id,
            table_heading,
            table_name,
            font_size
          );
          this.alert_exist = false;
        },
        cancelCallback: () => {
          this.warningAlert({
            text: 'cancelled',
            action: 'error',
          });
          this.alert_exist = false;
        },
      });
    }
  }

  Confirm_generatePDF(
    table_card_1,
    table_id,
    table_heading = 'REPORT',
    table_name = 'REPORT',
    font_size = 8
  ) {
    const doc = new jsPDF();
    const logoURL = '/assets/icon/logo_opaq.png'; // Replace with the correct path to your company logo image
    doc.addImage(logoURL, 'JPEG', 10, 10, 40, 15);
    doc.setTextColor(100, 107, 111);
    // const leftFooterContent = '+91 9489715036';
    const rightFooterContent = 'NEOSETTLEMENT.AWAREASSO.IN';

    const CurentDate = new Date().toISOString().substring(0, 10);
    const CurrentTime = new Date().toLocaleTimeString('en-US', {
      hour12: true,
    });
    const user_mobile = this.localStorage.getItem('mobile');

    const customFooter = (data: any) => {
      // Left footer
      doc.setFontSize(10);
      // doc.text(leftFooterContent, 10, doc.internal.pageSize.height - 10);
      // Right footer
      doc.text(
        rightFooterContent,
        doc.internal.pageSize.width - 50,
        doc.internal.pageSize.height - 10
      );
    };

    // Create an HTML structure for the card content
    // const cardContent = document.querySelector('#card');

    const cardData = document.getElementById(table_card_1);
    const tableData = [document.getElementById(table_id)];

    const cardTableParams = {
      theme: 'plain',
      startY: 38, // Adjust the Y coordinate to make space for the header
      body: cardData,
      styles: {
        fontSize: 8,
        halign: 'left', // Adjust text alignment as needed
        fontStyle: 'bold',
        cellWidth: 60, // Set a fixed column width
        cellSpace: 3,
      },
    };

    // to set table heading
    doc.setFontSize(16);
    doc.setTextColor(0);
    // (doc as any).setFont('bold');
    const captionText = table_heading;
    const textWidth =
      (doc.getStringUnitWidth(captionText) *
        (doc as any).internal.getFontSize()) /
      doc.internal.scaleFactor;
    const xOffset = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(captionText, xOffset, 30);

    const tableParams = {
      // theme: 'plain',
      // startY: 60, // Adjust the Y coordinate to make space for the header
      addPageContent: customFooter,
      // addPageContent1: customHeader,
      fontStyle: 'bold',
      body: tableData,
      styles: {
        fontSize: font_size, // Set the font size for the table content
        halign: 'left', // Right-aligned body text
        fontStyle: 'bold',
        cellWidth: 'warp', // Set a fixed column width
      },

      headStyles: {
        // Customize styles for the table headings
        fillColor: [108, 11, 169], // Background color as RGB (red)
        textColor: [255, 255, 255], // Text color as RGB (white)
        fontSize: font_size,
        halign: 'center',
        cellWidth: 'warp', // Set a fixed column width
        fontStyle: 'bold',
      },
      /**  ⭐ AUTO ALIGNMENT LOGIC HERE ⭐  */
      didParseCell: function (data) {
        const rawText = String(data.cell.text?.[0] ?? '').trim();

        // 1) Detect column header from autoTable (header row)
        let header = "";
        if (data.table && data.table.head && data.table.head[0]) {
          header = String(data.table.head[0].cells[data.column.index]?.text ?? "")
            .toLowerCase();
        }

        // 2) If header contains "amount" or "total" → align right
        if (header.includes("amount") || header.includes("total")) {
          data.cell.styles.halign = "right";
          return;
        }

        // 3) Normal numeric centering rule
        if (/^\d+(\.\d+)?$/.test(rawText)) {
          data.cell.styles.halign = "center";
        }
      },
      tableWidth: 190, //'190' 'auto' or 'wrap' to adjust table width automatically or 'wrap' to fit content
      margin: { top: 20, left: 10 },
      // Your table data here
    };

    // Add your table content for multiple pages
    // const tableData = [document.getElementById('curr_table')];

    // Function to add the table to the PDF
    const addTableToPDF = () => {
      (doc as any).autoTable({ html: '#' + table_id, ...tableParams });
    };
    const addCardToPDF = (cardTable: HTMLElement | null, params: any) => {
      if (cardTable) {
        (doc as any).autoTable({ html: cardTable, ...params });
      }
    };
    addCardToPDF(cardData, cardTableParams);
    // Loop to add the table content
    for (let i = 0; i < tableData.length; i++) {
      addTableToPDF();

      if (i === tableData.length - 1) {
        // Define your middle footer content
        const middleFooterContent =
          'Printed on ' +
          (CurentDate.split('-')[2] +
            '-' +
            CurentDate.split('-')[1] +
            '-' +
            CurentDate.split('-')[0]) +
          ' at ' +
          CurrentTime;

        const middleFooterContent1 =
          '          * End of Report *';
        doc.setFontSize(9);
        // doc.text(middleFooterContent, 65, (doc as any).autoTableEndPosY() + 10);
        // doc.text(
        //   middleFooterContent1,
        //   65,
        //   (doc as any).autoTableEndPosY() + 17
        // );
        const printedTextWidth =
    (doc.getStringUnitWidth(middleFooterContent) *
      (doc as any).internal.getFontSize()) /
    doc.internal.scaleFactor;
  const printedCenterX =
    (doc.internal.pageSize.width - printedTextWidth) / 2;

  doc.setFontSize(9);
  doc.text(
    middleFooterContent,
    printedCenterX,
    (doc as any).autoTableEndPosY() + 10
  );

  // End of Report (centered)
  const endTextWidth =
    (doc.getStringUnitWidth(middleFooterContent1) *
      (doc as any).internal.getFontSize()) /
    doc.internal.scaleFactor;
  const endCenterX =
    (doc.internal.pageSize.width - endTextWidth) / 2;

  doc.text(
    middleFooterContent1,
    endCenterX,
    (doc as any).autoTableEndPosY() + 17
  );
      }
    }

    // // Adding Page Numbers
    const pageCount = (doc as any).internal.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.text(
        '' + i,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 10,
        { align: 'center' }
      );
    }

    // Save or display the PDF
    doc.save(table_name + '.pdf');
  }

async generatePDF1(
  table_card_1,
  table_card_2,
  table_card_3,
  table_id,
  table_heading = 'REPORT',
  table_name = 'REPORT',
  font_size = 8
) {
  if (this.alert_exist == false) {
    this.alert_exist = true;

    this.confirmationAlert({
      text: 'Are You Sure Want To Download The Pdf ?',
      confirmCallback: () => {
        this.Confirm_generatePDF1(
          table_card_1,
          table_card_2,
          table_card_3,
          table_id,
          table_heading,
          table_name,
          font_size
        );
        this.alert_exist = false;
      },
      cancelCallback: () => {
        this.warningAlert({
          text: 'cancelled',
          action: 'error',
        });
        this.alert_exist = false;
      },
    });
  }
}

Confirm_generatePDF1(
  table_card_1,
  table_card_2,
  table_card_3,
  table_id,
  table_heading = 'REPORT',
  table_name = 'REPORT',
  font_size = 8
) {
  // ✅ LANDSCAPE ORIENTATION
  const doc = new jsPDF({ orientation: 'landscape' });

  const logoURL = '/assets/icon/logo_opaq.png';
  doc.addImage(logoURL, 'JPEG', 14, 10, 40, 15);
  doc.setTextColor(100, 107, 111);

  const rightFooterContent = 'NEOSETTLEMENT.AWAREASSO.IN';
  const CurentDate = new Date().toISOString().substring(0, 10);
  const CurrentTime = new Date().toLocaleTimeString('en-US', {
    hour12: true,
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const cardData = document.getElementById(table_card_1);
  const cardData1 = document.getElementById(table_card_2);
  const cardData2 = document.getElementById(table_card_3); 
  const tableData = [document.getElementById(table_id)];

  // ✅ Set table heading - centered in landscape
  doc.setFontSize(16);
  doc.setTextColor(0);
  const captionText = table_heading;
  const textWidth =
    (doc.getStringUnitWidth(captionText) *
      (doc as any).internal.getFontSize()) /
    doc.internal.scaleFactor;
  const xOffset = (pageWidth - textWidth) / 2;
  doc.text(captionText, xOffset, 20);

  // ✅ CARD PARAMS WITH SPACING - WHITE BACKGROUND FOR CARD 1
  // const cardTableParams = {
  //   theme: 'plain',
  //   styles: {
  //     fontSize: 9,
  //     halign: 'left',
  //     cellWidth: 'auto',
  //     cellSpacing: 2,
  //     cellPadding: 2,
  //     fillColor: [255, 255, 255], // White background
  //   },
  //   margin: { top: 2, left: 14, right: 14, bottom: 2 },
  //   didParseCell: function (data: any) {
  //     const cellText = String(data.cell.text[0] ?? '').trim();
      
  //     // ✅ Check if cell contains a label (ends with ":")
  //     if (cellText.includes(':')) {
  //       // ✅ HEADINGS: Bold Italic, Larger font (9pt)
  //       data.cell.styles.fontStyle = 'bolditalic';
  //       data.cell.styles.fontStyle = 'bolditalic';
  //       data.cell.styles.fontSize = 10; // ✅ Larger heading
  //     } else {
  //       // ✅ VALUES: Normal, smaller (7pt)
  //       data.cell.styles.fontStyle = 'normal';
  //       data.cell.styles.fontSize = 9;
  //     }
  //   },
  // };
const cardTableParams = {
  theme: 'grid', // ✅ adds border = highlight
  styles: {
    fontSize: 9,
    halign: 'center',
    valign: 'middle',
    cellPadding: 3,
    lineColor: [200, 200, 200],
    lineWidth: 0.3,
  },
  columnStyles: {
    0: { cellWidth: 55 },
    1: { cellWidth: 55 },
    2: { cellWidth: 55 },
    3: { cellWidth: 55 },
    4: { cellWidth: 60 },
  },
  didParseCell: function (data: any) {
    const text = data.cell.text.join(" ");

    // ✅ LABEL STYLE
    if (text.toLowerCase().includes('value') || text.toLowerCase().includes('extend')) {
      data.cell.styles.fontStyle = 'bold';
      data.cell.styles.fontSize = 10;
    }

    // ✅ VALUE STYLE (numbers)
    if (/\d/.test(text)) {
      data.cell.styles.fontStyle = 'bold';
      data.cell.styles.fontSize = 11;
      data.cell.styles.textColor = [0, 0, 0];
    }

    // ✅ PREVENT BREAKING
    data.cell.styles.cellWidth = 'wrap';
    data.cell.styles.overflow = 'linebreak'; // safe wrap
  },
};
  // ✅ CARD PARAMS FOR CARD 2 & 3 - GREEN BACKGROUND
  const cardTableParamsGreen = {
    theme: 'plain',
    styles: {
      fontSize: 8,
      halign: 'left',
      cellWidth: 'auto',
      cellSpacing: 2,
      cellPadding: 2,
      fillColor: [144, 238, 144], // #90ee90 in RGB: [144, 238, 144]
    },
    margin: { top: 2, left: 9, right: 9, bottom: 2 },
    didParseCell: function (data: any) {
      const cellText = String(data.cell.text[0] ?? '').trim();
      
      // ✅ Check if cell contains a label (ends with ":")
      if (cellText.includes(':')) {
        // ✅ HEADINGS: Bold Italic, Larger font (9pt)
        data.cell.styles.fontStyle = 'bold';
        data.cell.styles.fontSize = 8; 
      } else {
        // ✅ VALUES: Normal, smaller (7pt)
        data.cell.styles.fontStyle = 'bold';
        data.cell.styles.fontSize = 10;
      }
    },
  };

  const tableParams = {
    fontStyle: 'bold',
    body: tableData,
    styles: {
      fontSize: font_size,
      halign: 'left',
      fontStyle: 'bold',
      cellWidth: 'auto',
      minCellHeight: 3.6, // ✅ Further reduced to fit 19 rows + 1 more
    },
    headStyles: {
      fillColor: [108, 11, 169],
      textColor: [255, 255, 255],
      fontSize: font_size,
      halign: 'center',
      cellWidth: 'auto',
      fontStyle: 'bold',
    },
    didParseCell: function (data: any) {
      const rawText = String(data.cell.text?.[0] ?? '').trim();

      let header = "";
      if (data.table && data.table.head && data.table.head[0]) {
        header = String(data.table.head[0].cells[data.column.index]?.text ?? "")
          .toLowerCase();
      }

      if (header.includes("amount") || header.includes("total")) {
        data.cell.styles.halign = "right";
        return;
      }

      if (/^\d+(\.\d+)?$/.test(rawText)) {
        data.cell.styles.halign = "center";
      }
    },
    tableWidth: 280, // ✅ Table width increased
    margin: { top: 5, left: 10, right: 10, bottom: 20 },
  };

  // ✅ ADD CARDS BEFORE TABLE with proper spacing
  const addCardToPDF = (cardTable: HTMLElement | null, params: any) => {
    if (cardTable) {
      (doc as any).autoTable({ 
        html: cardTable, 
        ...params
      });
    }
  };

  // ✅ Add CARD 1 with WHITE background
  addCardToPDF(cardData, { ...cardTableParams, startY: 25 });
  
  let currentY = (doc as any).lastAutoTable?.finalY || 50;
  // ✅ Add CARD 2 with GREEN background
  addCardToPDF(cardData1, { ...cardTableParamsGreen, startY: currentY + 5 });

  // ✅ ADD MAIN TABLE with 20 rows on first page (1-20, fitting 19+1 extra)
  currentY = (doc as any).lastAutoTable?.finalY || 60;
  (doc as any).autoTable({ 
    html: '#' + table_id, 
    ...tableParams,
    startY: currentY + 10,
    rowPageBreak: 'avoid', // ✅ Prevent incomplete rows
    columnStyles: {},
    didDrawPage: function (data: any) {
      // ✅ Fit more rows including the 19th row
      if (data.table.body) {
        data.table.body.forEach((row: any) => {
          row.minCellHeight = 3.6; // ✅ Further compressed to fit 20 rows
        });
      }
    },
  });

  // ✅ ADD CARD 3 with GREEN background AFTER THE TABLE
  currentY = (doc as any).lastAutoTable?.finalY || 80;
  addCardToPDF(cardData2, { ...cardTableParamsGreen, startY: currentY + 10 });

  // ✅ FORMAT DATE
  const printedDate = CurentDate.split('-')[2] + '-' +
    CurentDate.split('-')[1] + '-' +
    CurentDate.split('-')[0];

  const middleFooterContent = 'Printed on ' + printedDate + ' at ' + CurrentTime;
  const middleFooterContent1 = '* End of Report *';

  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);

  const finalY = (doc as any).lastAutoTable?.finalY || (pageHeight - 30);

  // ✅ LEFT FOOTER
  doc.text(
    middleFooterContent,
    14,
    finalY + 10
  );

  // ✅ RIGHT FOOTER
  const endTextWidth =
    (doc.getStringUnitWidth(middleFooterContent1) *
      (doc as any).internal.getFontSize()) /
    doc.internal.scaleFactor;

  doc.text(
    middleFooterContent1,
    pageWidth - 14 - endTextWidth,
    finalY + 10
  );

  // ✅ Add page numbers and NEOSETTLEMENT
  const pageCount = (doc as any).internal.pages.length - 1;

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(9);
    doc.setTextColor(0, 0, 0);

    doc.text(
      '' + i,
      pageWidth / 2,
      pageHeight - 10,
      { align: 'center' } as any
    );

    const neosettlementWidth =
      (doc.getStringUnitWidth(rightFooterContent) *
        (doc as any).internal.getFontSize()) /
      doc.internal.scaleFactor;

    doc.text(
      rightFooterContent,
      pageWidth - 14 - neosettlementWidth,
      pageHeight - 10
    );
  }

  doc.save(table_name + '.pdf');
}


  // To convert a table to exel format
  async convertTableToCSV(tableId: string, fileName: string = 'Report') {
    if (this.alert_exist == false) {
      this.alert_exist = true;
      this.confirmationAlert({
        text: 'Are You Sure Want To Download The CSV File ?',
        confirmCallback: () => {
          this.Confirm_convertTableToCSV(tableId, fileName);
          this.alert_exist = false;
        },
        cancelCallback: () => {
          this.warningAlert({
            text: 'Cancelled',
            action: 'error',
          });
          this.alert_exist = false;
        },
      });
    }
  }

  Confirm_convertTableToCSV(tableId: string, fileName: string = 'report') {
    // Get the HTML table element by its ID
    const table = document.getElementById(tableId);

    // Check if the table exists
    if (!table) {
      console.error(`Table with ID "${tableId}" not found.`);
      return;
    }

    // Extract table data (rows and cells) and prepare CSV content
    const rows = table.querySelectorAll('tr');
    const csvContent = Array.from(rows, (row) =>
      Array.from(row.querySelectorAll('td, th'), (cell) =>
        cell.textContent.trim()
      ).join(',')
    ).join('\n');

    // Create a blob with the CSV content
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create a download link
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);

    // Append the link to the document body and trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  alert = {
    warningAlert: this.warningAlert,
    confirmationAlert: this.confirmationAlert,
    confirmationAlert1: this.confirmationAlert1,
  };

  private warningAlert(props: {
    title?: string;
    text: string;
    action?: 'success' | 'update' | 'delete' | 'warning' | 'error';
    iconColor?: string;
    iconHtml?: string;
    btnColor?: string;
    btnText?: string;
    callback?: () => void;
    // customClass?: {
    //   [key: string]: string
    // }
  }) {
    const {
      title,
      text,
      action,
      iconColor,
      btnColor,
      btnText,
      iconHtml,
      callback,
    } = props;
    let sweetAlertIcon: SweetAlertIcon;
    let setColor: string;
    let setIconHtml: string;
    let setTitle: string;

    switch (action) {
      case 'success':
        setTitle = 'Successful';
        setIconHtml =
          '<i class="fa-solid fa-check fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#30a702';
        break;
      case 'update':
        setTitle = 'Updated';
        setIconHtml =
          '<i class="fa-solid fa-check fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#0000FF';
        break;
      case 'delete':
        setTitle = 'Deleted';
        setIconHtml =
          '<i class="fa-regular fa-trash-can fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#FF0000';
        break;
      case 'warning':
        setTitle = 'Warning!';
        setIconHtml =
          '<i class="fa-solid fa-exclamation fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#F6BE00';
        break;
      case 'error':
        setTitle = 'Error!';
        setIconHtml =
          '<i class="fa-solid fa-x fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#FF0000';
        break;
      default:
        setTitle = '';
        setIconHtml =
          '<i class="fa-solid fa-check fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#6C0BA9';
        break;
    }

    setColor = iconColor || setColor;

    let iconProps: { iconHtml?: string; icon?: SweetAlertIcon } = {
      iconHtml: iconHtml || setIconHtml,
    };
    if (!iconProps.iconHtml) {
      iconProps = { icon: sweetAlertIcon };
    }

    Swal.fire({
      title: title || setTitle,
      html: text,
      iconColor: setColor,
      confirmButtonColor: btnColor || '',
      confirmButtonText: btnText || 'OK',
      customClass: { popup: 'cus-sweet-alert' },
      ...iconProps,
      // customClass: {
      //   icon: 'no-border'
      // },
    }).then(callback);

    document.body.classList.remove('swal2-height-auto'); // to align modal vertically centered
  }

  private confirmationAlert(props: {
    title?: string;
    text: string;
    action?: 'delete' | 'warning' | 'logout';
    iconColor?: string;
    iconHtml?: string;
    confirmBtnText?: string;
    confirmBtnColor?: string;
    cancelBtnText?: string;
    cancelBtnColor?: string;
    confirmCallback?: () => void;
    cancelCallback?: () => void;
  }) {
    const {
      title,
      text,
      action,
      iconColor,
      iconHtml,
      confirmBtnText,
      confirmBtnColor,
      cancelBtnText,
      cancelBtnColor,
      confirmCallback = () => { },
      cancelCallback = () => { },
    } = props;
    let sweetAlertIcon: SweetAlertIcon;
    let setColor: string;
    let setIconHtml: string;

    switch (action) {
      case 'delete':
        setIconHtml =
          '<i class="fa-regular fa-trash-can fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#FF0000';
        break;
      case 'warning':
        setIconHtml =
          '<i class="fa-solid fa-exclamation fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#F6BE00';
        break;
      case 'logout':
        setIconHtml =
          '<i class="fa-solid fa-arrow-right-from-bracket fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#6C0BA9';
        break;
      default:
        setIconHtml =
          '<i class="fa-solid fa-exclamation fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
        setColor = '#6C0BA9';
        break;
    }

    setColor = iconColor || setColor;

    let iconProps: { iconHtml?: string; icon?: SweetAlertIcon } = {
      iconHtml: iconHtml || setIconHtml,
    };
    if (!iconProps.iconHtml) {
      iconProps = { icon: sweetAlertIcon };
    }

    Swal.fire({
      title: title || 'Are you sure?',
      text: text,
      iconColor: setColor,
      showCancelButton: true,
      confirmButtonText: confirmBtnText || 'Confirm',
      confirmButtonColor: confirmBtnColor || '#FF7900',
      cancelButtonText: cancelBtnText || 'Cancel',
      cancelButtonColor: cancelBtnColor,
      // reverseButtons: true,
      customClass: { popup: 'cus-sweet-alert' },
      ...iconProps,
    }).then((result) => {
      if (result.isConfirmed) {
        confirmCallback();
        } else if (
        result.isDismissed &&
        result.dismiss === Swal.DismissReason.cancel
      ) {
        cancelCallback();
      }
    });
    document.body.classList.remove('swal2-height-auto'); // to align modal vertically centered
  }
  private confirmationAlert1(props: {
    title?: string;
    text: string;
    action?: 'delete' | 'warning' | 'logout';
    iconColor?: string;
    iconHtml?: string;
    confirmBtnText?: string;
    confirmBtnColor?: string;
    cancelBtnText?: string;
    cancelBtnColor?: string;
    confirmCallback?: () => void;
    cancelCallback?: () => void;
  }) {
    const {
      title,
      text,
      action,
      iconColor,
      iconHtml,
      confirmBtnText,
      confirmBtnColor,
      cancelBtnText,
      cancelBtnColor,
      confirmCallback = () => { },
      cancelCallback = () => { },
    } = props;
    let sweetAlertIcon: SweetAlertIcon;
    let setColor: string;
    let setIconHtml: string;

    // switch (action) { 
    //   case 'delete':
    //     setIconHtml =
    //       '<i class="fa-regular fa-trash-can fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
    //     setColor = '#FF0000';
    //     break;
    //   case 'warning':
    //     setIconHtml =
    //       '<i class="fa-solid fa-exclamation fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
    //     setColor = '#F6BE00';
    //     break;
    //   case 'logout':
    //     setIconHtml =
    //       '<i class="fa-solid fa-arrow-right-from-bracket fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
    //     setColor = '#6C0BA9';
    //     break;
    //   default:
    //     setIconHtml =
    //       '<i class="fa-solid fa-exclamation fa-shake" style="--fa-animation-duration: 2s; --fa-animation-iteration-count: 1;"></i>';
    //     setColor = '#6C0BA9';
    //     break;
    // }

    setColor = iconColor || setColor;

    let iconProps: { iconHtml?: string; icon?: SweetAlertIcon } = {
      iconHtml: iconHtml || setIconHtml,
    };
    if (!iconProps.iconHtml) {
      iconProps = { icon: sweetAlertIcon };
    }

    Swal.fire({
      title: title || '⚠️ Attention/கவனிக்க',
      // text: text,
      html: text,
      iconColor: setColor,
      showCancelButton: true,
      confirmButtonText: confirmBtnText || 'Confirm',
      confirmButtonColor: confirmBtnColor || '#FF7900',
      cancelButtonText: cancelBtnText || 'Cancel',
      cancelButtonColor: cancelBtnColor,
      // reverseButtons: true,
      customClass: { popup: 'cus-sweet-alert' },
      ...iconProps,
    }).then((result) => {
      if (result.isConfirmed) {
        confirmCallback();
      }  else if (
        result.isDismissed &&
        result.dismiss === Swal.DismissReason.cancel
      )  {
        cancelCallback();
      }
    });
    document.body.classList.remove('swal2-height-auto'); // to align modal vertically centered
  }

  // Define showResultAlert function
  showResultAlert(title: string, text: string, icon: SweetAlertIcon) {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    });
    document.body.classList.remove('swal2-height-auto'); // to align modal vertically centered
  }

  // // Define showSweetAlert_forDelete function
  // showSweetAlert_forDelete(title: string, text: string) {
  //   const handleResult = (result: any) => {
  //     if (result.isConfirmed) {
  //       showResultAlert("Deleted!", "Your file has been deleted.", "success");
  //     } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
  //       showResultAlert("Cancelled", "Your file is safe", "error");
  //     }
  //     document.body.classList.remove('swal2-height-auto');
  //   };

  //   Swal.fire({
  //     title: title,
  //     text: text,
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonText: "No, cancel!",
  //     reverseButtons: true
  //   }).then(handleResult);
  // }

  relational_date_validation(startDate, endDate) {
    if (new Date(startDate) < new Date(endDate)) {
      return true;
    } else if (new Date(startDate) > new Date(endDate)) {
      return false;
    }
  }

  check_email_id(id) {
    var emVal = $(id).val();
    if (emVal != '') {
      var regem =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{3,}))$/;

      if (!regem.test(String(emVal))) {
        // this.api.presentAlert("Please Enter Valid Email Id")

        // this.alert.warningAlert({
        //   text: "Please Enter Valid Email Id",
        //   action: 'warning',
        //   callback:()=> {
        //     setTimeout(function () {
        //       $(id).focus()
        //     }, 500);
        //   }
        // })

        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  // to check if the text contains only alpabets (a-z) or (A-Z)

  check_only_alphabet(id) {
    var text = $(id).val();

    var regapha = /^[A-Za-z]+$/;

    if (regapha.test(String(text)) || text == '') {
      return true;
    } else {
      return false;
    }
  }

  // only allow ALphapets

  keyPressAlphaNumeric(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (/^[a-zA-Z\s]$/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  check_only_wholenumber(txt: string) {
    var num_reg = /^[0-9]+$/;
    return num_reg.test(txt);
  }

  check_only_decimalnumber(txt: string) {
    var num_reg = /^\d+(\.\d+)?$/;
    return num_reg.test(txt);
  }

  // Only Integer Numbers
  keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  // Only Integer Numbers and Dot
  keyPressNumbersAndDot(event) {
    var charCode = event.which ? event.which : event.keyCode;
    var inp = String.fromCharCode(event.keyCode);
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      if (/^[.\s]$/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    } else {
      return true;
    }
  }

  postData_with_stringUrl(
    url: string,
    data: any,
    stringData: any,
    responseType: any
  ): Observable<any> {
    const httpOptions = {
      url: url,
      method: 'POST',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.get_session_id_login(),
        modname: stringData,
      }),
      responseType: responseType,
    };

    return this.http.post(url, data, httpOptions);
  }


  // to check file Size

  validateFileSize2Mp(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const files = fileInput.files;

    if (files && files.length > 0) {
      const file = files[0];
      const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
      // const maxSizeInBytes = 200 * 1024; // 200 KB

      if (file.size > maxSizeInBytes) {
        this.alert.warningAlert({
          text: 'File Size Must be Less than 2 MB.',
          action: 'warning',
          callback: () => {
          },
        });
        // Clear the file input to allow the user to select a different file
        fileInput.value = '';

        return false
      }
      else {
        return true
      }
    }
  }

    validateFileSize1mb(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const files = fileInput.files;

    if (files && files.length > 0) {
      const file = files[0];
      // const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
      // const maxSizeInBytes = 200 * 1024; // 200 KB
      const maxSizeInBytes = 1024 * 1024; // 400 KB

      if (file.size > maxSizeInBytes) {
        this.alert.warningAlert({
          text: 'File Size Must be Less than 1MB.',
          action: 'warning',
          callback: () => {
          },
        });
        // Clear the file input to allow the user to select a different file
        fileInput.value = '';

        return false
      }
      else {
        return true
      }
    }
  }
  validateFileSize200Kb(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const files = fileInput.files;

    if (files && files.length > 0) {
      const file = files[0];
      // const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
      // const maxSizeInBytes = 200 * 1024; // 200 KB
      const maxSizeInBytes = 400 * 1024; // 400 KB

      if (file.size > maxSizeInBytes) {
        this.alert.warningAlert({
          text: 'File Size Must be Less than 400 KB.',
          action: 'warning',
          callback: () => {
          },
        });
        // Clear the file input to allow the user to select a different file
        fileInput.value = '';

        return false
      }
      else {
        return true
      }
    }
  }
validateFileSize5Mp(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const files = fileInput.files;

    if (files && files.length > 0) {
      const file = files[0];
      // const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
      // const maxSizeInBytes = 200 * 1024; // 200 KB
      const maxSizeInBytes = 5 * 1024 * 1024;

      if (file.size > maxSizeInBytes) {
        this.alert.warningAlert({
          text: 'File Size Must be Less than 400 KB.',
          action: 'warning',
          callback: () => {
          },
        });
        // Clear the file input to allow the user to select a different file
        fileInput.value = '';

        return false
      }
      else {
        return true
      }
    }
  }
  validateFileSize1Mp(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const files = fileInput.files;

    if (files && files.length > 0) {
      const file = files[0];
      const maxSizeInBytes = 1 * 1024 * 1024; // 2 MB

      if (file.size > maxSizeInBytes) {
        this.alert.warningAlert({
          text: 'File Size Must be Less than 1 MB.',
          action: 'warning',
          callback: () => {
          },
        });
        // Clear the file input to allow the user to select a different file
        fileInput.value = '';

        return false
      }
      else {
        return true
      }
    }
  }

  // validateFileSize5Mp(event: Event) {
  //   const fileInput = event.target as HTMLInputElement;
  //   const files = fileInput.files;

  //   if (files && files.length > 0) {
  //     const file = files[0];
  //     const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB

  //     if (file.size > maxSizeInBytes) {
  //       this.alert.warningAlert({
  //         text: 'File Size Must be Less than 5 MB.',
  //         action: 'warning',
  //         callback: () => {
  //         },
  //       });
  //       // Clear the file input to allow the user to select a different file
  //       fileInput.value = '';

  //       return false
  //     }
  //     else {
  //       return true
  //     }
  //   }
  // }


  call_http_get(getObj: GetDataType): Subscription {
    const {
      url,
      modname = '',
      successCb = (response) => { },
      errorCb,
      afterError,
      completeCb = this.defaultCompleteHandler,
    }: GetDataType = getObj;

    const headers = {
      Authorization: this.get_session_id_login(),
    };

    let errorHandlerCb = (error) => { };
    if (!errorCb && !afterError) {
      errorHandlerCb = this.defaultErrHandler;
    } else if (errorCb) {
      errorHandlerCb = errorCb;
    } else if (afterError) {
      errorHandlerCb = (error) => {
        this.defaultErrHandler(error, () => {
          afterError(error);
        });
      };
    }

    return this.http
      .get(this.appendParamsToGetUrl(url, { modname }), {
        headers,
      })
      .pipe(
        finalize(completeCb)
        // called on both sucess and error
      )
      .subscribe({ next: successCb, error: errorHandlerCb });
    // .subscribe({
    //   next: successCb, error: errorHandlerCb,
    //   complete: () => {
    //     // called after success/next only, not called after error
    //   },
    // })
  }


  call_http_post(
    postObj: PostDataType,
    control_spinner_locally: boolean = false
  ): Subscription {
    const {
      url,
      modname = '',
      allowpage = false,
      isFormData = false,
      responseType,
      successCb = (response) => { },
      errorCb,
      afterError,
      completeCb = this.defaultCompleteHandler,
    }: PostDataType = postObj;

    let data = postObj.data;
    if (!data) {
      if (isFormData) data = new FormData();
      else data = {};
    }

    if (isFormData) {
      if (!data.get('modname')) data.append('modname', modname);
      if (!data.get('allowpage')) data.append('allowpage', allowpage);
    } else {
      if (!data['modname']) data = { ...data, modname, allowpage };
    }

    const headers = {
      Authorization: this.get_session_id_login(),
    };

    if (!isFormData) headers['Content-Type'] = 'application/json';

    const requestOptions = {
      headers,
    };

    if (responseType) requestOptions['responseType'] = responseType;

    let errorHandlerCb = (error) => { };
    if (!errorCb && !afterError) {
      errorHandlerCb = (err) => {
        this.defaultErrHandler(err);
      };
    } else if (errorCb) {
      errorHandlerCb = errorCb;
    } else if (afterError) {
      errorHandlerCb = (error) => {
        this.defaultErrHandler(error);
        afterError(error);
      };
    }

    // // using Http.request doesnt get intercepted by HttpInterceptor
    // const options: HttpOptions = { url, method: 'POST', headers, data };
    // return from(Http.request(options));

    if (!control_spinner_locally) this.show_spinner = true;

    return this.http
      .post(url, data, requestOptions)
      .pipe(
        finalize(() => {
          if (!control_spinner_locally) this.show_spinner = false;
          completeCb();
        })
      )
      .subscribe({ next: successCb, error: errorHandlerCb });
  }

  // -------------------------------siyyon parvat----------------------------
  formatRefNumber(user_id: number): string {
    return 'R' + user_id.toString().padStart(8, '0');
  }




  refresh_captcha(options: {
    modname: string;
    captchaInputSelector: string;
    captchaImgSelector: string;
    onCaptchaLoad?: () => void;
    onCaptchaLoadErr?: (err) => void;
  }) {
    let {
      modname,
      captchaInputSelector, // = '#capt',
      captchaImgSelector = "[name='captcha2']",
      onCaptchaLoad = () => { },
      onCaptchaLoadErr = (err) => { },
    } = options;

    console.log(modname, 'Checking ');
    if (captchaInputSelector) $(captchaInputSelector).val('');

    let cpt_key = this.cpt_views[modname]['cptid-keyname'];
    console.log(
      'test cpt id :',
      this.cpt_views[modname],
      this.cpt_session_keys[modname],
      this.localStorage.getItem(cpt_key)
    );
    // console.log('test', this.api.localStorage.getItem(cpt_key))
    fetch(environment.API_URL + 'captcha/captcha_image', {
      // credentials: 'include',  // to use set-cookie header
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        // to reuse the session used to load previous captcha if page already loaded
        // to reuse the session used in verify mobile number section of registration pages
        last_used_cptid: this.localStorage.getItem(cpt_key) || '',
        modname,
      }),
    })
      .then((res) => {
        this.cpt_session_keys[modname] = res.headers.get('x-cptid') || '';
        if (environment.production) {
          // console.log('test cookie :', this.cookies.get('sp_sid'));
          // this.cpt_session_key = this.cookies.get(cpt_key);
        }
        console.log(this.cpt_session_keys, 'key');
        this.localStorage.setItem(cpt_key, this.cpt_session_keys[modname]);
        return res.blob();
      })
      .then((blob) => {
        let URLcreator = window.URL || window.webkitURL;
        let captImgTempUrl = URLcreator.createObjectURL(blob);
        let $capt_img = $(captchaImgSelector);
        $capt_img.attr('src', captImgTempUrl);
        $capt_img[0].onload = () => {
          URLcreator.revokeObjectURL(captImgTempUrl);
          onCaptchaLoad();
        };
      })
      .catch((err) => {
        console.log(err);
        onCaptchaLoadErr(err);
      });
  }

  verify_captcha(options: {
    modname: string;
    captchaInputSelector: string;
    captchaInputVal: string;
    captchaImgSelector: string;
    onCaptchaVerified?: (res) => void;
    onComplete?: () => void;
  }) {
    const {
      modname,
      captchaInputSelector,
      captchaInputVal,
      captchaImgSelector,
      onCaptchaVerified = (res) => { },
      onComplete = () => { },
    } = options;
    let errCallBk = this.common_errorCb;

    let cpt_key = this.cpt_views[modname]['cptid-keyname'];
    let captcha_data = {
      captcha_entered: captchaInputVal,
      cpt_id: this.localStorage.getItem(cpt_key) || '',
      modname,
    };
    console.log(captcha_data);

    this.call_http_post({
      url: environment.API_URL + 'captcha/verify_captcha',
      data: captcha_data,
      successCb: (result) => {
        try {
          let { verified = false, message, session = 'valid' } = result.data;
          if (!verified) {
            onComplete();
            if (message) {
              // Show Captcha Input Validation Error Message
              this.alert.warningAlert({
                text: message,
                action: 'error',
                callback: () => {
                  setTimeout(function () {
                    $(captchaInputSelector).focus();
                  }, 500);
                },
              });
            } else {
              let expiredCaptcha = session == 'invalid';
              this.alert.warningAlert({
                text: expiredCaptcha ? 'Captcha Expired' : 'Invalid Captcha',
                action: 'error',
                callback: () => {
                  if (expiredCaptcha) {
                    this.refresh_captcha({
                      modname,
                      captchaInputSelector,
                      captchaImgSelector,
                    });
                  }
                  setTimeout(function () {
                    $(captchaInputSelector).focus();
                  }, 500);
                },
              });
            }
            return;
          }
        } catch (error) {
          errCallBk(error);
          onComplete();
        }
        onCaptchaVerified(result);
      },
      afterError: () => {
        onComplete();
      },
    });
  }

  CurrentDate(dateInput) {

    if (dateInput) {
      const today = new Date();
      // Format date to 'yyyy-MM-dd'
      const formattedDate = today.toISOString().substring(0, 10);
      dateInput.value = formattedDate;
    }
  }


  formatDateToDDMMYYYY(dateStr: string): string {
    // Assuming dateStr is in the format 'YYYY-MM-DD'
    const [year, month, day] = dateStr.split('-');

    // Return the date in 'DD-MM-YYYY' format
    return `${day}-${month}-${year}`;
  }

  setCurrentDateTime(dateInput: string): string {
    if (!dateInput) {
      return '';  // Handle empty or invalid input
    }

    // Convert the input string into a Date object
    const date = new Date(dateInput);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid Date';  // Handle invalid date input
    }

    // Manually format the date as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Months are zero-indexed in JS
    const day = String(date.getDate()).padStart(2, '0');

    // Get the hours, minutes, and seconds
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Determine AM or PM and adjust hours for 12-hour format
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;  // If hours = 0, set to 12 for midnight/noon
    const formattedHours = String(hours).padStart(2, '0');

    // Combine the formatted date and time
    return `${day}-${month}-${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
  }


  check_outer_session() {
    const isAndroid = Capacitor.getPlatform() === 'android';
    if (!isAndroid) {
      const session_time = this.localStorage.getItem('session_time');
      const pagesession = this.localStorage.getItem('pagesession');

      if (session_time) {
        const expirationTime = new Date(session_time);
        const now = new Date();

        if ((now < expirationTime) && pagesession) {
          // Still valid 
          this.extend_outer_session()
        } else {
          this.outer_logout()
        }
      }

    }
  }

  extend_outer_session() {
    const currentTime = new Date();
    const session_time = new Date(currentTime.getTime() + 60 * 60 * 1000); // Add 1 hour

    this.localStorage.setItem('session_time', session_time.toISOString());
  }

  outer_logout() {
    localStorage.removeItem('pagesession'); // Optionally clear it                                            
    localStorage.removeItem('session_time');
    // this.router.navigate(['/home'])
    window.location.href = '/home';
  }
  async confirmExitApp() {
    if (this.alert_exist == false) {
      this.alert_exist = true;
      this.alert.confirmationAlert({
        title: 'Confirmation',
        text: 'Are You Sure Want To Exit The App?',
        action: 'warning',
        confirmBtnText: 'Yes, proceed',
        cancelBtnText: 'No, cancel',
        confirmCallback: () => {
          this.alert_exist = false;
          App.exitApp();
        },
        cancelCallback: () => {
          this.alert_exist = false;
        },
      });
    }
  }


  //Navigate Spinner 
  async spinnerAndNavigate(route: string = '/') {
    const loading = await this.loadingController.create({
      message: 'Loading...',
      spinner: 'bubbles',
      duration: 0
    });

    await loading.present();

    this.router.navigate([route]).then(() => {
      loading.dismiss();
    }).catch(() => {
      loading.dismiss();
    });
  }
  view_privew_url_src_only(doc) {
    var url = environment.API_URL + 'media' + '/' + doc;
    return url
  }
  view_privew_url(doc) {
    var url = environment.API_URL + 'media' + '/' + doc;
    window.open(url, '_blank');
  }
  verify_cur_loading_pg_privilege() {
    this.call_http_post({
      url: environment.API_URL + 'mastermodule/VerifyPagePrivilage',
      data: {
        modname: this.DefaultModuleName,
        user_id: this.localStorage.getItem('user_id'),
        user_type: this.localStorage.getItem('user_type'),
      },
      successCb: (res: any) => {
        // let result = res?.data;
        // console.log('page privilage verifying :', { result });
        // let { dt = [], message } = result;

         let result = res; // ✅ IMPORTANT CHANGE

      console.log('page privilege verifying:', result);

      if (result.error) {
        // ❌ No permission
        console.log(result.detail);

        // optional redirect
        // this.router.navigate(['/no-access']);

        return;
      }

      // ✅ Access granted
      console.log('Permission OK');
      },
    });
  }
// amountToWords(num: number): string {
//   if (!num || isNaN(num)) return "Zero";

//   const ones = [
//     "", "One", "Two", "Three", "Four", "Five",
//     "Six", "Seven", "Eight", "Nine", "Ten",
//     "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
//     "Sixteen", "Seventeen", "Eighteen", "Nineteen"
//   ];

//   const tens = [
//     "", "", "Twenty", "Thirty", "Forty",
//     "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
//   ];

//   function twoDigits(n: number): string {
//     if (n < 20) return ones[n];
//     return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
//   }

//   function convert(n: number): string {
//     let out = "";

//     if (n >= 1000000000000) { // Lakh Crore (10^12)
//       out += convert(Math.floor(n / 1000000000000)) + " Lakh Crore ";
//       n %= 1000000000000;
//     }

//     if (n >= 10000000000) { // Thousand Crore (10^10)
//       out += convert(Math.floor(n / 10000000000)) + " Thousand Crore ";
//       n %= 10000000000;
//     }

//     if (n >= 10000000) { // Crore
//       out += convert(Math.floor(n / 10000000)) + " Crore ";
//       n %= 10000000;
//     }

//     if (n >= 100000) { // Lakh
//       out += convert(Math.floor(n / 100000)) + " Lakh ";
//       n %= 100000;
//     }

//     if (n >= 1000) { // Thousand
//       out += convert(Math.floor(n / 1000)) + " Thousand ";
//       n %= 1000;
//     }

//     if (n >= 100) { // Hundred
//       out += ones[Math.floor(n / 100)] + " Hundred ";
//       n %= 100;
//     }

//     if (n > 0) {
//       if (out !== "") out += "and ";
//       out += twoDigits(n);
//     }

//     return out.trim();
//   }

//   return convert(num).trim();
// }

amountToWords(num: number): string {
  if (!num || isNaN(num)) return "Zero Rupees";

  const ones = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const tens = [
    "", "", "Twenty", "Thirty", "Forty",
    "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  function twoDigits(n: number): string {
    if (n < 20) return ones[n];
    return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
  }

  function convert(n: number): string {
    let out = "";

    if (n >= 10000000) { // Crore
      out += convert(Math.floor(n / 10000000)) + " Crore ";
      n %= 10000000;
    }

    if (n >= 100000) { // Lakh
      out += convert(Math.floor(n / 100000)) + " Lakh ";
      n %= 100000;
    }

    if (n >= 1000) { // Thousand
      out += convert(Math.floor(n / 1000)) + " Thousand ";
      n %= 1000;
    }

    if (n >= 100) { // Hundred
      out += ones[Math.floor(n / 100)] + " Hundred ";
      n %= 100;
    }

    if (n > 0) {
      out += twoDigits(n) + " ";
    }

    return out;
  }

  return convert(num).replace(/\s+/g, " ").trim() + " Rupees";
}

  // SplitUrl(url: String) {
  //   if (this.DefaultModuleName?.length) {
  //     return this.DefaultModuleName;
  //   } else {
  //     var parts = url.split('/');
  //     var lastPart = parts[parts.length - 1].split(';')[0];
  //     this.DefaultModuleName = lastPart;
  //     return lastPart;
  //   }
  // }
}



